module.exports = __webpack_public_path__ + "static/media/asahi_sorad9c51a35bf4ee99ae42f13b569dbdd43.webp";